import ProjectsDashboardPage from "./ProjectsDashboardPage";

export default ProjectsDashboardPage;
